import { URL_EMBEDDED_SOAT } from "@/consts/embbed";
import { getParameterEmbeddedValue } from "@/utils/helpers";
import { useMemo } from "react";

const useRecommendedProductUrl = (baseLink) => {
  return useMemo(() => {
    const urlEmbedded = localStorage.getItem(URL_EMBEDDED_SOAT);
    let link = baseLink;

    if (urlEmbedded) {
      const params = ["celular", "tipoDocumento", "nroDocumento", "canal"];
      const queryParams = params
        .map((param) => {
          const value = getParameterEmbeddedValue(param, urlEmbedded);
          return value ? `&${param}=${value}` : "";
        })
        .join("");

      link += queryParams;
    }

    return link;
  }, [baseLink]);
};

export default useRecommendedProductUrl;
